import axios from 'axios'

import { AkivaRequest } from './types'

export const create = async (request: AkivaRequest) => {
  const url = process.env.NEXT_PUBLIC_AKIVA_URL + '/interact'

  if (
    typeof navigator !== 'undefined' &&
    typeof navigator.sendBeacon === 'function'
  ) {
    beaconRequest(url, request)
  } else {
    httpRequest(url, request)
  }
}

const httpRequest = (url: string, request: AkivaRequest) => {
  axios.post(url, request).catch(() => {})
}

const beaconRequest = (url: string, request: AkivaRequest) => {
  const data = new Blob([JSON.stringify(request)], { type: 'application/json' })

  navigator.sendBeacon(url, data)
}
